import { ConsultorioCokiba, HorariosAtencion, HorariosAtencionRegistrado } from 'types/Consultorio';

interface Resultado {
  ok: boolean;
  message?: string;
}

export function consultorioLabel(c: Pick<ConsultorioCokiba, 'nombreConsultorio' | 'direccion' | 'numero'>): string {
  if (c.nombreConsultorio) {
    return c.nombreConsultorio;
  }

  const partes = [c.direccion, c.numero]
    .filter(v => v !== undefined && v !== null && `${v}` !== '');
  return partes.join(' ').trim() || 'Sin identificar';
}

export function horariosRegistradosFromConsultorios(
  consultorios: ConsultorioCokiba[],
  excluirConsultorioId?: number,
): HorariosAtencionRegistrado[] {
  return consultorios.flatMap(consultorio => {
    if (excluirConsultorioId !== undefined && consultorio.idConsultorio === excluirConsultorioId) {
      return [];
    }

    const nombre = consultorioLabel(consultorio);
    return (consultorio.horarios ?? []).map(horario => ({
      diaSemana: horario.diaSemana,
      horaInicio: horario.horaInicio,
      horaFin: horario.horaFin,
      consultorio_nombre: nombre,
    }));
  });
}

export function validarSolapamientos(
  nuevos: HorariosAtencion[],
  actuales: HorariosAtencionRegistrado[] = [],
): Resultado {
  const items: HorariosAtencionRegistrado[] = [
    ...actuales,
    ...nuevos.map(h => ({ ...h })),
  ];

  for (const h of items) {
    if (!h.diaSemana || !h.horaInicio || !h.horaFin) {
      return { ok: false, message: 'Todos los campos son obligatorios.' };
    }

    if (h.horaInicio >= h.horaFin) {
      return {
        ok: false,
        message: `La hora de inicio debe ser anterior a la hora de fin (${h.diaSemana}).`,
      };
    }
  }

  for (let i = 0; i < items.length; i++) {
    for (let j = i + 1; j < items.length; j++) {
      const h1 = items[i];
      const h2 = items[j];
      if (h1.diaSemana?.toUpperCase() !== h2.diaSemana?.toUpperCase()) {
        continue;
      }

      const i1 = h1.horaInicio;
      const f1 = h1.horaFin;
      const i2 = h2.horaInicio;
      const f2 = h2.horaFin;

      if (!i1 || !i2 || !f1 || !f2) {
        continue;
      }

      const solapan = (i1 < f2 && f1 > i2) || i1 === i2;
      if (!solapan) {
        continue;
      }

      const nombre1 = h1.consultorio_nombre;
      const nombre2 = h2.consultorio_nombre;

      if (nombre1 && nombre2) {
        if (nombre1 === nombre2) {
          return {
            ok: false,
            message: `Los horarios registrados del consultorio "${nombre1}" se solapan el día ${h1.diaSemana}.`,
          };
        }
        return {
          ok: false,
          message: `Los horarios registrados de los consultorios "${nombre1}" y "${nombre2}" ` +
            `se solapan el día ${h1.diaSemana}.`,
        };
      }

      if (nombre1 || nombre2) {
        return {
          ok: false,
          message: `El nuevo horario del día ${h1.diaSemana} se solapa con el del consultorio "${nombre1 || nombre2}".`,
        };
      }

      return {
        ok: false,
        message: `Hay horarios superpuestos el día ${h1.diaSemana}.`,
      };
    }
  }

  return { ok: true };
}
